module.exports = {
      id: "crime-usage",
      viewBox: "0 0 69.07 72.614",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#crime",
      toString: function () {
        return this.url;
      }
    }